export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 100 100" fill="none">
            <path d="M50 88C70.9868 88 88 70.9868 88 50C88 29.0132 70.9868 12 50 12C29.0132 12 12 29.0132 12 50C12 70.9868 29.0132 88 50 88Z" fill="#3F68E0" />
            <path
                d="M31.0524 48.2058L33.816 67.0386H49.2965H66.0035L68.7671 48.2058"
                stroke="white"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M32.595 47.5676L49.9725 57.6191L67.2246 47.5676" stroke="white" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M68.7673 46.8482C70.4531 46.8482 71.8198 45.4815 71.8198 43.7957C71.8198 42.1098 70.4531 40.7432 68.7673 40.7432C67.0814 40.7432 65.7148 42.1098 65.7148 43.7957C65.7148 45.4815 67.0814 46.8482 68.7673 46.8482Z"
                stroke="white"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M31.0525 46.8482C32.7383 46.8482 34.105 45.4815 34.105 43.7957C34.105 42.1098 32.7383 40.7432 31.0525 40.7432C29.3666 40.7432 28 42.1098 28 43.7957C28 45.4815 29.3666 46.8482 31.0525 46.8482Z"
                stroke="white"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M42.8046 52.9643L49.9071 40.6289L57.0096 52.9643" stroke="white" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M49.9071 39.773C52.0536 39.773 53.7936 38.0329 53.7936 35.8865C53.7936 33.74 52.0536 32 49.9071 32C47.7607 32 46.0206 33.74 46.0206 35.8865C46.0206 38.0329 47.7607 39.773 49.9071 39.773Z"
                stroke="white"
                strokeWidth="3.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
